module.exports = __webpack_public_path__ + "static/media/pc-image-background-checker-pattern-2.9fd23e49.svg";